module.exports = __webpack_public_path__ + "static/beeldmerk-dee8faee5dbcaa3ff6b07bf9b4387d29.svg";